import React, { useEffect, useState } from "react";
import avatar from "../../../images/no-image.png";
import postImage from "../../../images/t-10.jpg";
import axios from "axios";
import CardBackground from "./CardBackground";
import dayjs from "dayjs";
import moment from "moment";

import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";
import { HiUser, HiDotsHorizontal, HiCalendar, HiClock, HiHeart, HiOutlineHeart, HiThumbUp, HiOutlineThumbUp, HiX, HiPlay } from 'react-icons/hi';

const PostComponent = () => {
  const [{ errorLogApi, placeHolderText, user }] = useAtom(gbState);
  const [data, setData] = useState([]);

  let userImage = localStorage.getItem("user_image");

  useEffect(() => {
    const getDataFromServer = () => {
      let userToken = localStorage.getItem("token");

      let urlLink = `${process.env.REACT_APP_API_URL}/post/${user.church_id}`;

      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      axios(config)
        .then(function (response) {
          const oldData = response.data.posts;
          const updatedData = oldData.map((data) => ({
            ...data,
            id: data._id,
            title: data.title,
            description: data.description,
            file_type: data.file_type,
            upload_file: data.upload_file,
            likes: 0, // Initialize likes state
          }));
          setData(updatedData);
          // Fetch likes for each post
          updatedData.forEach((post) => {
            getNumberOfLikes(post._id);
          });
        })
        .catch(function (err) {
          console.log("error api call ", err);
        });
    };
    getDataFromServer();
  }, []);

  const getNumberOfLikes = (id) => {
    let userToken = localStorage.getItem("token");

    let urlLink = `${process.env.REACT_APP_API_URL}/like/${id}`;

    const config = {
      method: "GET",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios(config)
      .then(function (response) {
        const likes = response?.data?.likes;
        setData((prevData) =>
          prevData.map((post) =>
            post.id === id ? { ...post, likes: likes } : post
          )
        );
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  };

  const addLikeToPost = (id) => {
    let userToken = localStorage.getItem("token");

    let urlLink = `${process.env.REACT_APP_API_URL}/like/add/${id}`;

    const config = {
      method: "POST",
      url: urlLink,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios(config)
      .then(function (response) {
        getNumberOfLikes(id);
      })
      .catch(function (err) {
        console.log("error api call ", err);
      });
  };

  return (
    <div className="space-y-6">
      {/* Header Section */}
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold text-gray-900">Church Updates</h2>
        <div className="hidden sm:block">
          <div className="p-3 bg-white rounded-xl shadow-sm">
            <div className="flex items-center space-x-2">
              <HiHeart className="w-5 h-5 text-rose-500" />
              <span className="text-sm font-medium text-gray-600">
                {data?.length || 0} Updates
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Posts List */}
      {data && data.length > 0 ? (
        data.map((item, index) => (
          <div key={index} className="overflow-hidden bg-white rounded-xl shadow-sm">
            <div className="p-6">
              {/* Post Header */}
              <div className="flex justify-between items-start">
                <div className="flex items-center space-x-4">
                  {item?.created_by?.image && item?.created_by?.image !== "undefined" ? (
                    <img
                      crossOrigin="anonymous"
                      src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/employee/${item?.created_by?.image}`}
                      className="object-cover w-12 h-12 rounded-full border-2 border-gray-100"
                      alt={`${item?.created_by?.first_name}'s profile`}
                    />
                  ) : (
                    <div className="flex justify-center items-center w-12 h-12 bg-gray-100 rounded-full">
                      <HiUser className="w-6 h-6 text-gray-400" />
                    </div>
                  )}
                  <div>
                    <h3 className="font-medium text-gray-900">
                      {item?.created_by?.first_name} {item?.created_by?.last_name}
                      <span className="ml-1 font-normal text-gray-500">shared an update</span>
                    </h3>
                    <p className="text-sm text-gray-500">
                      {moment(item.createdAt).fromNow()}
                    </p>
                  </div>
                </div>
                <button className="p-2 text-gray-400 rounded-full transition-colors duration-200 hover:bg-gray-50">
                  <HiDotsHorizontal className="w-5 h-5" />
                </button>
              </div>

              {/* Post Content */}
              <div className="mt-4">
                <h4 className="text-lg font-medium text-gray-900">{item.title}</h4>
                <p className="mt-2 text-gray-600">{item.description}</p>
              </div>

              {/* Post Metadata */}
              <div className="mt-4 space-y-2">
                <div className="flex items-center text-gray-500">
                  <HiCalendar className="mr-2 w-5 h-5" />
                  <span className="text-sm">
                    {dayjs(item.createdAt).format("MMMM DD, dddd YYYY")}
                  </span>
                </div>
                <div className="flex items-center text-gray-500">
                  <HiClock className="mr-2 w-5 h-5" />
                  <span className="text-sm">
                    {dayjs(item.createdAt).format("hh:mm A")}
                  </span>
                </div>
              </div>

              {/* Media Content */}
              {item?.upload_file && (
                <div className="overflow-hidden mt-4 rounded-lg">
                  {item?.file_type === "image" ? (
                    <img
                      src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/post/${item?.upload_file}`}
                      className="object-cover w-full rounded-lg"
                      alt={item.title}
                      crossOrigin="anonymous"
                    />
                  ) : item?.file_type === "video" ? (
                    <div className="relative bg-black rounded-lg">
                      <video
                        controls
                        className="w-full"
                        crossOrigin="anonymous"
                      >
                        <source
                          src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/post/${item?.upload_file}`}
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  ) : null}
                </div>
              )}

              {/* Post Actions */}
              <div className="flex items-center pt-4 mt-4 space-x-6 border-t border-gray-100">
                <button
                  onClick={() => addLikeToPost(item.id)}
                  className="flex items-center text-gray-500 transition-colors duration-200 hover:text-indigo-600"
                >
                  {item.hasLiked ? (
                    <HiThumbUp className="w-5 h-5" />
                  ) : (
                    <HiOutlineThumbUp className="w-5 h-5" />
                  )}
                  <span className="ml-2 text-sm font-medium">
                    {item.likes} {item.likes === 1 ? 'Like' : 'Likes'}
                  </span>
                </button>
                <button className="flex items-center text-gray-500 transition-colors duration-200 hover:text-rose-600">
                  {item.hasLoved ? (
                    <HiHeart className="w-5 h-5" />
                  ) : (
                    <HiOutlineHeart className="w-5 h-5" />
                  )}
                  <span className="ml-2 text-sm font-medium">Love</span>
                </button>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="flex flex-col justify-center items-center p-8 text-center bg-white rounded-xl">
          <HiHeart className="w-16 h-16 text-gray-300" />
          <h3 className="mt-4 text-lg font-semibold text-gray-900">No Updates Yet</h3>
          <p className="mt-1 text-gray-500">Check back later for new community updates.</p>
        </div>
      )}
    </div>
  );
};

export default PostComponent;
